const EXPLORE = [
  { label: "现场速递", href: "#feed" },
  { label: "影像图证", href: "#docs" },
  { label: "话题索引", href: "#index" },
  { label: "目击者说", href: "#witness" },
];

const APPROACH = [
  { label: "关于 911网", href: "#method" },
  { label: "怎么看真伪", href: "#top" },
  { label: "去档案下发言", href: "#discuss" },
];

export default function Footer() {
  return (
    <footer className="border-t border-foreground-200 bg-secondary-100 text-foreground-800">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-6">
          <div className="md:col-span-6">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-[16px]" aria-hidden="true" />
              </span>
              <span className="font-serif text-xl font-black tracking-tight text-foreground-950">911网</span>
            </a>
            <p className="mt-4 max-w-md text-[13px] leading-6 text-foreground-600">
              现场视频、实拍、图片流出，与目击者说、截图线索同场对齐的持续档案。
              看画面细节，别隔着转述判断真假，视觉素材一把抓。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-foreground-300 text-foreground-600 transition-colors hover:border-primary-500 hover:text-primary-600">
                <i className="ri-questionnaire-line text-[16px]" aria-hidden="true" />
              </span>
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-foreground-300 text-foreground-600 transition-colors hover:border-primary-500 hover:text-primary-600">
                <i className="ri-message-3-line text-[16px]" aria-hidden="true" />
              </span>
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-foreground-300 text-foreground-600 transition-colors hover:border-primary-500 hover:text-primary-600">
                <i className="ri-send-plane-line text-[16px]" aria-hidden="true" />
              </span>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-foreground-950">内容浏览</h4>
            <ul className="mt-4 space-y-3">
              {EXPLORE.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-[13px] text-foreground-600 transition-colors hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-foreground-950">站点信息</h4>
            <ul className="mt-4 space-y-3">
              {APPROACH.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-[13px] text-foreground-600 transition-colors hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-foreground-300/70 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-[12px] text-foreground-500">
            © 2026 911网 · 现场资料聚合档案。本站为单页静态演示页，页内材料与数据均为示意，未接入真实数据库、登录或提交。
          </p>
          <p className="text-[12px] text-foreground-500">
            目击者说与截图线索仅作整理参考，判定请以画面与多方对照为准。
          </p>
        </div>
      </div>
    </footer>
  );
}